import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import Global from '@/scripts/Global'

/*** Components  */
import FolderContent from '@/components/RightSidebar/FolderContent/FolderContent.vue';
import KeyboardShortcut from '@/components/RightSidebar/KeyboardShortcut/KeyboardShortcut.vue';
import Conference from '@/components/RightSidebar/Conference/Conference.vue';
import ChannelUsers from '@/components/RightSidebar/ChannelUsers/ChannelUsers.vue';
import ChannelSettings from '@/components/RightSidebar/ChannelSettings/ChannelSettings.vue';
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'RightSidebar',
    data() {
        return {
            rightSidebarCollapsed: SessionManager.getLoggedInUser().chat_visuals.sidebar_collapsed,
            showRightSidebarMobile: false,
            rightSidebarTheme: 'channel_users',
            channelType: SessionManager.getActiveChannel().type,
            needsPermission: false,
            windowScreen: window.screen.width
        }
    },
    components: {
        ChannelUsers,
        FolderContent,
        KeyboardShortcut,
        ChannelSettings,
        Conference,
    },
    mounted() {
        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (ch_id) => {
            this.showRightSidebarMobile = false // for mobile
        })

        serverBus.$on(VueSignals.ACTIVE_POSSIBLE_CHANGED, (success) => {
            this.showRightSidebarMobile = false // for mobile
        })

        serverBus.$on(VueSignals.LOGGED_IN_USER, (success) => {
            this.rightSidebarCollapsed = SessionManager.getLoggedInUser().chat_visuals.sidebar_collapsed
        })


        serverBus.$on(VueSignals.RIGHT_SIDEBAR_COLLAPSED, (right_sidebar_collapsed) => {
            this.rightSidebarCollapsed = right_sidebar_collapsed
        });


        // @TODO check it again the unlogic
        serverBus.$on(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, (statue) => {
            this.showRightSidebarMobile = statue

            if (this.showRightSidebarMobile) {
                Global.setOpenMenu('right')
            } else {
                Global.setOpenMenu('')
            }
        })

        serverBus.$on(VueSignals.RIGHT_SIDEBAR_THEME, (theme) => {
            this.rightSidebarTheme = theme
        })

        serverBus.$on(VueSignals.NOTIFICATION_NEED_PERMISSION, (status) => {
            this.needsPermission = status
        })

        if (this.channels_length == 0) {
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'folder_content')
            Global.globalValue(VueSignals.ACTIVATED_VIEW, 'Folder')
        }
    },
    methods: {
        UsersList() {
            Global.AddActionAnalytics("Channel Users")
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'channel_users')
        },
        ChannelSettings() {
            Global.AddActionAnalytics("Channel Settings")
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'channel_settings')
        },
        ChannelFolders() {
            Global.AddActionAnalytics("Folder Content")
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'folder_content')
        },
        KeyboardShortcuts() {
            Global.AddActionAnalytics("Keyboard Shortcut")
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'keyboard_shortcut')
        },
        Conference() {
            Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'conference')
        },
        toogleRightSideBar() {
            Global.globalValue(VueSignals.TOOGLE_RIGHT_SIDE_BAR, true);
        },
        closeRightAndOpenLeft() {
            Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, true);
            Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false);
            Global.setOpenMenu('left')
        },
        closeLeftAndRightBars() {
            Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false);
            Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false);
        }
    }
}
